export default __webpack_public_path__ + "media/images/mailer-new/store-icons/btn-google-play-d87c693f3cf230be6ab2f9fe2972f8c0.png";